// src/components/ArticleCard/ArticleCard.tsx
import React from 'react';
import { Article, CategorieArticle } from '../../data/types';
import './ArticleCard.css';

interface ArticleCardProps {
  article: Article;
  categorie: CategorieArticle;
  onClick: () => void;
}

const ArticleCard: React.FC<ArticleCardProps> = ({ article, categorie, onClick }) => {
  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div 
      className="article-card"
      onClick={onClick}
      style={{ '--category-color': categorie.couleur } as React.CSSProperties}
    >
      <div className="article-card-header">
        <div className="article-category" style={{ backgroundColor: categorie.couleur }}>
          {categorie.titre}
        </div>
        <div className="article-meta">
          <span className="article-date">{formatDate(article.datePublication)}</span>
          <span className="article-reading-time">{article.tempsLecture}</span>
        </div>
      </div>

      <div className="article-card-content">
        <h3 className="article-title">{article.titre}</h3>
        {article.sousTitre && (
          <p className="article-subtitle">{article.sousTitre}</p>
        )}
        
        {/* Affichage de l'aperçu s'il existe */}
        {article.apercu && (
          <div className="article-apercu">
            <p>{article.apercu}</p>
          </div>
        )}

        <div className="article-tags">
          {article.tags.slice(0, 3).map((tag, index) => (
            <span key={index} className="article-tag">
              {tag}
            </span>
          ))}
          {article.tags.length > 3 && (
            <span className="article-tag-more">
              +{article.tags.length - 3}
            </span>
          )}
        </div>
      </div>

      <div className="article-card-footer">
        <div className="article-author">
          <span>Par {article.auteur}</span>
        </div>
        
        {/* Message d'incitation à la lecture */}
        <div className="read-more">
          <span>Cliquer pour lire →</span>
        </div>
      </div>
    </div>
  );
};

export default ArticleCard;